import { render } from "./RequestRecovery.vue?vue&type=template&id=81d1229a"
import script from "./RequestRecovery.vue?vue&type=script&lang=js"
export * from "./RequestRecovery.vue?vue&type=script&lang=js"
script.render = render

export default script